<template>
  <div class="LoadingSpinner"></div>
</template>
